<template>
  <div class="sky__product-dashboard-wrapper relative">
    <div class="sky__product-dashboard flex flex-col">
      <!-- a) Titre - Hidden on mobile -->
      <div class="hidden lg:block order-1">
        <product-dashboard-header
          :product="product"
        />
      </div>

      <!-- b) Référence (gauche) + Avis (droite) - Hidden on mobile -->
      <div class="hidden lg:flex justify-between items-center mb-3 order-2">
        <small class="text-sm text-sky_grey font-bold">#{{ product.sku }}</small>
        <product-dashboard-reviews
          v-if="product.properties.reviews"
          :product="product"
        />
      </div>

      <!-- c) Avantages - Desktop: après avis, Mobile: après stock -->
      <product-dashboard-bullet-points
        v-if="product.properties.bulletPoints && product.properties.bulletPoints.length"
        :product="product"
        class="order-7 lg:order-3"
      />

      <!-- d) Variations - Desktop: après avantages, Mobile: après ronds -->
      <product-variants
        :product="product"
        class="order-9 lg:order-4"
      />

      <!-- e) Prix - Hidden on mobile -->
      <decreasing-prices
        v-if="product.pricing.decreasing_prices.length"
        v-model="quantity"
        class="mb-4 order-5"
        :product="product"
      />
      <price-dashboard
        :quantity="quantity"
        :product="product"
        class="mb-4 hidden lg:flex order-5"
      />

      <!-- f) Ajout au panier - Hidden on mobile -->
      <div v-if="product.properties.stock_status === 'available_later'" class="mb-4 bg-yellow-500 px-2 py-2 rounded text-white order-6">
        Ce produit sera expédié le {{ $helpers.formatDate(product.properties.eta) }}
      </div>
      <div class="hidden lg:block order-6">
        <add-to-cart-input
          v-if="product.properties.stock_status !== 'out_of_stock'"
          class="mb-4"
          :quantity.sync="quantity"
          :loading="addingToCart"
          :pcb="product.pricing.pcb"
          @add="addToCart"
        />
        <add-out-of-stock-email
          v-else
          class="mb-4"
          :product-id="product.sku"
        />
      </div>

      <!-- g) Bloc "En stock" / Livraison - Mobile: premier, Desktop: après panier -->
      <product-delivery-info
        :product="product"
        class="order-first lg:order-7"
      />

      <!-- h) 3 ronds - Mobile: après bullet points, Desktop: après livraison -->
      <product-dashboard-reinsurances
        v-if="product.properties.reinsurances && product.properties.reinsurances.length"
        :product="product"
        class="order-8 lg:order-8"
      />

      <!-- i) Pictos réassurance - Toujours en dernier -->
      <product-dashboard-footer class="order-last" />
    </div>
  </div>
</template>

<script>
import DecoratedFeatureValue from '../general/DecoratedFeatureValue'
import VariantMenu from './VariantMenu'
import StockStatus from './StockStatus'
import DecreasingPrices from './DecreasingPrices'
import PriceDashboard from './PriceDashboard'
import AddToCartInput from './AddToCartInput'
import AddOutOfStockEmail from './AddOutOfStockEmail'
import ProductVariants from './ProductVariants'
import ProductDashboardHeader from './dashboard/ProductDashboardHeader'
import ProductDashboardReviews from './dashboard/ProductDashboardReviews'
import ProductDashboardBulletPoints from './dashboard/ProductDashboardBulletPoints'
import ProductDashboardReinsurances from './dashboard/ProductDashboardReinsurances'
import ProductDashboardFooter from './dashboard/ProductDashboardFooter'
import ProductDeliveryInfo from './ProductDeliveryInfo'

export default {
  components: {
    AddToCartInput,
    DecreasingPrices,
    VariantMenu,
    DecoratedFeatureValue,
    StockStatus,
    PriceDashboard,
    AddOutOfStockEmail,
    ProductVariants,
    ProductDashboardHeader,
    ProductDashboardReviews,
    ProductDashboardBulletPoints,
    ProductDashboardReinsurances,
    ProductDashboardFooter,
    ProductDeliveryInfo
  },
  props: {
    product: {
      required: true,
      type: Object
    }
  },
  data () {
    return {
      quantity: this.product.pricing.pcb,
      addingToCart: false
    }
  },
  watch: {
    'product.pricing.pcb' (val) {
      this.quantity = val
    }
  },
  methods: {
    async addToCart (e) {
      this.addingToCart = true
      try {
        const { price } = await this.$store.dispatch('cart/addProduct', {
          sku: this.product.sku,
          quantity: e,
          cover: this.product.cover,
          label: this.product.label,
          pricing: this.product.pricing,
          properties: {
            path: this.product.path,
            uri: this.$helpers.makeUri(this.product.path),
            background: this.product.properties.background,
            crossed_price: this.$store.getters['auth/paysTaxes'] ? this.product.pricing.crossed_taxed_price : this.product.pricing.crossed_price
          }
        })
        this.$gtmEvents.onAddedToCart(this.product, e, price, 'Fiche Produit')
        this.$store.commit('cart/setShow', true)
      } catch (error) {
        this.$gtmEvents.onRuntimeError(error, 'product/add-to-cart')
        // GTM peut être lui-même indisponible : on trace côté serveur.
        if (this.$trace) {
          this.$trace('ajout_panier_echec', {
            origine: 'fiche-produit',
            sku: this.product && this.product.sku,
            message: (error && error.message) || String(error)
          })
        }
      }
      this.addingToCart = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .sky__product-dashboard {
    @screen lg {
      @apply mx-8 mt-4 sticky;
      top: 120px;
    }
  }
  .sky__product-dashboard-wrapper {
    max-width: 100%;
    width: 450px;
    @apply px-4;
  }
</style>
